var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerUpLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 20C22.75 20.4142 22.4142 20.75 22 20.75C21.5858 20.75 21.25 20.4142 21.25 20V12.7143C21.25 11.4717 20.2426 10.4643 19 10.4643H8.30556V15.4286C8.30556 15.7339 8.12053 16.0087 7.83768 16.1235C7.55483 16.2383 7.23061 16.1703 7.01781 15.9514L1.46225 10.2371C1.17925 9.94603 1.17925 9.48259 1.46225 9.1915L7.01781 3.47722C7.23061 3.25834 7.55483 3.19028 7.83768 3.30511C8.12053 3.41994 8.30556 3.69475 8.30556 4.00002V8.96431H19C21.0711 8.96431 22.75 10.6432 22.75 12.7143V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerUpLeft);
export default __webpack_public_path__ + "static/media/corner-up-left.12bd051fe2f420aa2725cf8e98742bfa.svg";
export { ForwardRef as ReactComponent };